import * as z from 'zod';

import { VISITOR_TYPE } from 'src/features/visitor/types';

export type PricingPlanObjectFormSchemaValues = z.infer<typeof pricingPlanObjectFormSchema>;
export const pricingPlanObjectFormSchema = z.object({
    valid_from: z.string(),
    valid_to: z.string().optional().nullable(),
    pricing_plan_identity: z.string(),
    site: z.string().optional(),
    zone: z.string().optional(),
    gateway: z.string().optional(),
    // Which visitors the assignment prices - nothing selected means every type of them
    visitor_types: z.array(z.nativeEnum(VISITOR_TYPE)).optional(),
    // Whether the plan is assigned here as an exception (e.g. for the holidays) rather than as the standard tariff
    is_exception: z.boolean().optional(),
});
